import React from 'react';
import PropTypes from 'prop-types';
import { adopt } from 'react-adopt';
import { Query } from '@apollo/react-components';
import gql from 'graphql-tag';
import get from 'lodash/get';

import { ContributePageConsumer } from '../../context';
import ContributionMatch from './contribution-match';

export const GET_MATCH = gql`
    query CampaignById($id: ID!) {
        campaign: campaignById(id: $id) {
            id
            match {
                id
                name
                isOptional
                messaging {
                    pledgeStatement
                    donationStatement
                    activationStatement
                    termsOfService
                }
            }

            sponsor {
                logoDark {
                    id
                }
            }
        }
    }
`;

/* eslint-disable react/prop-types, react/destructuring-assignment */
const Wrapper = adopt(
    {
        context: <ContributePageConsumer />,
        matchQuery: ({ context, render }) => (
            <Query query={GET_MATCH} variables={{ id: context.campaign.id }}>
                {render}
            </Query>
        ),
    },
    ({ context, matchQuery }) => ({
        context,
        error: matchQuery.error,
        loading: matchQuery.loading,
        sponsor: get(matchQuery, 'data.campaign.sponsor'),
        match: get(matchQuery, 'data.campaign.match'),
    })
);
/* eslint-enable react/prop-types, react/destructuring-assignment */

const ContributionMatchContainer = ({ isMatched, onChange }) => (
    <Wrapper>
        {({ error, loading, context, match, sponsor }) => {
            if (error) throw error;
            if (loading) return null;

            const { contribution } = context;
            const { isOptional } = match;
            const isPledge = contribution.type === 'pledge';

            let message;
            if (isMatched && isPledge) {
                message = match.messaging.pledgeStatement;
            } else if (isMatched && !isPledge) {
                message = match.messaging.donationStatement;
            } else {
                message = match.messaging.activationStatement;
            }

            return (
                <ContributionMatch
                    name={match.name}
                    message={message}
                    isOptional={isOptional}
                    isMatched={isMatched}
                    terms={match.messaging.termsOfService}
                    logo={get(sponsor, 'logoDark.id')}
                    onChange={onChange}
                />
            );
        }}
    </Wrapper>
);

ContributionMatchContainer.propTypes = {
    isMatched: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ContributionMatchContainer;
